export default {
	danger: '#e53935',
	green: '#136f40',
	yellow: '#e7b032',
	swal: '#2c4cff',
	orange: '#FB8C00',
	blue: '#2c4cff',
	orangeTable: '#FFCC80',
	greenTable: '#8BC34A',
	redTable: '#EF5350',
	blueTable: '#42A5F5',
	white: '#fff',
	chartRed: '#ff6384',
	chartGreen: '#49aa43',
	chartAccepted: '#2c4cff',
	chartRejected: '#6f69d7',
	chartAll: '#6b8bfc',
	chartMarine: '#2453a1',
	chartYellow: '#febd25',
	chartBorder: '#1b1b1b',
	green_light: '#46fca5',
	gray: '#3f3f3f',
	facebook: '#2C4CFF',
	instagram: '#EB4A66',
	api: '#73B9FF',
	whatsapp: '#1aaa53',
	tiktok: '#27F2EE',
	range1: '#40c5fe',
	range2: '#9c29ff',
	range3: '#144bb7',
	range4: '#2bff6d',
	black: '#000'
}